module.exports = __webpack_public_path__ + "static/media/teach.3cf94302.webp";